import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "@air/primitive-button";
import { Modal, ModalCloseButton } from "@air/primitive-modal";
import Image from "next/image";
import image from "~/assets/out_of_storage_background.png";
export const OutOfStorageModal = (param)=>{
    let { onClose } = param;
    return /*#__PURE__*/ _jsxs(Modal, {
        isOpen: true,
        onDismiss: onClose,
        children: [
            /*#__PURE__*/ _jsx("header", {
                className: "mb-6 flex items-center justify-end",
                children: /*#__PURE__*/ _jsx(ModalCloseButton, {
                    className: "shrink-0",
                    onClick: onClose
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-col items-center justify-center",
                children: [
                    /*#__PURE__*/ _jsx(Image, {
                        src: image,
                        alt: "Out of storage",
                        width: 200,
                        height: 200,
                        className: "object-cover"
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "my-4 text-24 font-semibold text-grey-12",
                        children: "This workspace is out of storage."
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "mb-8 text-center text-16 text-grey-12",
                        children: "Contact the owner of this board so they can add more storage to their workspace."
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        size: "large",
                        appearance: "filled",
                        color: "blue",
                        onClick: onClose,
                        children: "Ok, got it"
                    })
                ]
            })
        ]
    });
};
